import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function SortIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'TextSubtleGrey', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { d: "M4 7h16M6.133 11h11.734M8.266 15h7.466M10.398 19h3.2", stroke: primaryFillColor, strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}
//# sourceMappingURL=Sort.js.map